/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import { ValueUpdateDetail } from '../utils/UNSAFE_valueUpdateDetail';

type RadioGroupContextValue = {
  name: string;
  value?: string;
  onCommit?: (detail: ValueUpdateDetail<string>) => void;
};

const RadioGroupContext = createContext<RadioGroupContextValue>({} as RadioGroupContextValue);
const useRadioGroupContext = () => useContext(RadioGroupContext);

export { RadioGroupContext, useRadioGroupContext };
